import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';

const deletePpeComponentQuery = (id) => {
    return axios.delete(`${apiurl?.deletePpeComponent}/${id}`);
};

    const deletePpeComponent = () => {
        const queryClient = useQueryClient();
        return useMutation(deletePpeComponentQuery, {
            onSuccess: () => {
                showAlert('PPE Component Deleted Successfully!', 'success');
                queryClient.invalidateQueries('getPpeComponentList');
            },
            onError: (error) => {
              showAlert(error?.response?.data, 'error');
            }
        });
    };

export default deletePpeComponent;
